// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const LoopNone = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M15.908 59.051c-4.259-12.388-1.165-25.825 8.077-35.066 9.241-9.242 22.68-12.336 35.066-8.077a2 2 0 0 1-1.3 3.782c-10.93-3.756-22.785-1.028-30.938 7.123-8.15 8.152-10.88 20.006-7.123 30.938a2 2 0 1 1-3.782 1.3Zm2.678 18.363a1.998 1.998 0 0 1 0-2.828l56-56a2 2 0 1 1 2.828 2.828l-56 56a1.996 1.996 0 0 1-2.828 0Zm18.362 2.677a2 2 0 1 1 1.301-3.783c10.931 3.76 22.785 1.03 30.937-7.122 8.153-8.152 10.881-20.007 7.122-30.938a2 2 0 0 1 3.783-1.3c4.26 12.388 1.166 25.825-8.077 35.066-6.498 6.498-15.07 9.958-23.894 9.958-3.726 0-7.494-.616-11.172-1.88Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default LoopNone;
